/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=8b29d69c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=8b29d69c&lang=css"

import exportComponent from "D:\\VueDev\\smnc-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__